// kompres gambar di browser sebelum upload agar ringan untuk koneksi lambat
// jika gagal / hasil lebih besar, file asli yang dikembalikan
const compressImage = (file, maxSize = 1600, quality = 0.7) => {
    return new Promise((resolve) => {
        if (!file || !file.type || file.type.indexOf('image/') !== 0) {
            return resolve(file)
        }
        const url = URL.createObjectURL(file)
        const img = new Image()
        img.onload = () => {
            try {
                let { width, height } = img
                if (width > maxSize || height > maxSize) {
                    const ratio = Math.min(maxSize / width, maxSize / height)
                    width = Math.round(width * ratio)
                    height = Math.round(height * ratio)
                }
                const canvas = document.createElement('canvas')
                canvas.width = width
                canvas.height = height
                const ctx = canvas.getContext('2d')
                // background putih untuk png transparan
                ctx.fillStyle = '#ffffff'
                ctx.fillRect(0, 0, width, height)
                ctx.drawImage(img, 0, 0, width, height)
                canvas.toBlob((blob) => {
                    URL.revokeObjectURL(url)
                    if (!blob || blob.size >= file.size) {
                        return resolve(file)
                    }
                    const name = file.name.replace(/\.[^/.]+$/, '') + '.jpg'
                    resolve(new File([blob], name, { type: 'image/jpeg', lastModified: file.lastModified }))
                }, 'image/jpeg', quality)
            } catch (err) {
                URL.revokeObjectURL(url)
                resolve(file)
            }
        }
        img.onerror = () => {
            URL.revokeObjectURL(url)
            resolve(file)
        }
        img.src = url
    })
}

export default compressImage
